module.exports = __webpack_public_path__ + "img/secure-vpn-safe.a7fb1d3b.webp";